'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../data/index.js');
var dataType_enum = require('../data/data-type.enum.js');

/**
 * Expression validator result.
 *
 * @export
 * @interface ExpressionValidateResult
 */
/**
 * Define helper functions for semantic check
 *
 * @export
 * @namespace ExpressionValidator
 */
exports.ExpressionValidator = void 0;
(function (_ExpressionValidator) {
  function isInt(type) {
    return type === dataType_enum.DataType.Int;
  }
  _ExpressionValidator.isInt = isInt;
  function isReal(type) {
    return type === dataType_enum.DataType.Real;
  }
  _ExpressionValidator.isReal = isReal;
  function isNumeric(type) {
    return isInt(type) || isReal(type);
  }
  _ExpressionValidator.isNumeric = isNumeric;
  function isString(type) {
    return type === dataType_enum.DataType.String;
  }
  _ExpressionValidator.isString = isString;
  function isBoolean(type) {
    return type === dataType_enum.DataType.Bool;
  }
  _ExpressionValidator.isBoolean = isBoolean;
  function isVertexOrEdge(type) {
    return type === dataType_enum.DataType.VertexOrEdge;
  }
  _ExpressionValidator.isVertexOrEdge = isVertexOrEdge;
})(exports.ExpressionValidator || (exports.ExpressionValidator = {}));
